<template>
    <div class="activity-detail-panel-footer">
        <CompassTooltip
            :disabled="canBeUpdated"
            :content="$t.__('common.labels.no_permissions_to_perform_this_action')"
            :arrow="false"
        >
            <ActivitiesRescheduleDatePicker
                v-if="canReschedule"
                :modelValue="activityDate"
                placement="top-end"
                @update:modelValue="(modelValue) => $emit('updateDueDate', modelValue)"
            >
                <CompassButton
                    :loading="isReschedulePending"
                    type="secondary"
                    :dropdown="true"
                    :label="$t.__('activities.detailPanel.ActivityDetailPanel.rescheduleButton')"
                    :disabled="!canBeUpdated"
                />
            </ActivitiesRescheduleDatePicker>
        </CompassTooltip>

        <CompassTooltip
            :disabled="canBeUpdated"
            :content="$t.__('common.labels.no_permissions_to_perform_this_action')"
            :arrow="false"
        >
            <ActivityUpdateStatusButton
                :isDone="isDone"
                :disabled="!canBeUpdated"
                :pending="pending"
                :label="statusButtonLabel"
                :statusButtonType="statusButtonType"
                :hasDropdown="hasDropdown"
                @updateStatus="(createNewTask) => $emit('updateStatus', createNewTask)"
            />
        </CompassTooltip>
    </div>
</template>
<script>
import ActivityUpdateStatusButton from 'vcomponents/activities/ActivityUpdateStatusButton.vue';
import ActivitiesRescheduleDatePicker from 'vcomponents/activities/ActivitiesRescheduleDatePicker.vue';

export default {
    components: { ActivityUpdateStatusButton, ActivitiesRescheduleDatePicker },
    props: {
        activityDate: {
            type: String,
            required: true,
        },
        isDone: {
            type: Boolean,
            default: false,
        },
        pending: {
            type: Boolean,
            default: false,
        },
        canReschedule: {
            type: Boolean,
            default: false,
        },
        canBeUpdated: {
            type: Boolean,
            default: false,
        },
        isReschedulePending: {
            type: Boolean,
            required: true,
        },
        hasDropdown: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statusButtonLabel() {
            return this.isDone ? this.$l10n.__('Terminé') : this.$l10n.__('Marquer comme terminé');
        },

        statusButtonType() {
            return this.isDone ? 'secondary' : 'primary';
        },
    },
};
</script>

<style lang="scss" scoped>
.activity-detail-panel-footer {
    display: flex;
    justify-content: end;
    padding: var(--spacing-3) var(--spacing-5);
    gap: var(--spacing-3);
    border-top: 1px solid var(--colors-common-border-default);
    background: var(--colors-common-background-default);
}
</style>
